<div class="card mb-3">
	<div class="card-header d-flex justify-content-between align-items-center">
		<strong>{{'multi_tariff.rates.rates' | translate}}</strong>
		<button
			*ngIf="!readonly"
			type="button"
			class="btn btn-sm btn-primary"
			[disabled]="rates.length >= maxRates"
			(click)="addRate()"
		>
			{{'multi_tariff.rates.add_rate' | translate}}
		</button>
	</div>

	<div class="card-body">
		<div class="alert alert-danger" *ngIf="invalidFields?.rates?.minOrMax">
			{{'multi_tariff.rates.rates' | translate}}: {{'g.invalid_input' | translate}}
		</div>

		<div class="border rounded p-3 mb-3" *ngFor="let rate of rates; let rateIndex = index">
			<div class="row align-items-center mb-3">
				<label class="col-md-2"><strong>{{'multi_tariff.rates.name' | translate}} <span>*</span></strong></label>
				<div class="col-md-4">
					<input
						type="text"
						class="form-control"
						name="rateName{{rateIndex}}"
						maxlength="100"
						[disabled]="readonly"
						[ngClass]="{'border border-danger': invalidFields?.rates?.[rateIndex]?.name}"
						[(ngModel)]="rate.name"
						(ngModelChange)="emit()"
					/>
				</div>
				<div class="col-md-6 text-right">
					<button
						*ngIf="!readonly"
						type="button"
						class="btn btn-sm btn-outline-danger"
						(click)="removeRate(rateIndex)"
					>
						{{'multi_tariff.rates.remove_rate' | translate}}
					</button>
				</div>
			</div>

			<div class="alert alert-warning py-1" *ngIf="invalidFields?.rates?.[rateIndex]?.periods?.fullDay">
				{{'multi_tariff.rates.periods_full_day' | translate}}
			</div>
			<div class="alert alert-warning py-1" *ngIf="invalidFields?.rates?.[rateIndex]?.periods?.overlap">
				{{'multi_tariff.rates.periods_overlap' | translate}}
			</div>
			<div class="alert alert-warning py-1" *ngIf="invalidFields?.rates?.[rateIndex]?.periods?.minOrMax">
				{{'multi_tariff.rates.period' | translate}}: {{'g.invalid_input' | translate}}
			</div>

			<div class="table-responsive">
				<table class="table table-sm mb-2">
					<thead>
						<tr>
							<th>{{'multi_tariff.rates.period_name' | translate}}</th>
							<th>{{'multi_tariff.rates.period_from' | translate}}</th>
							<th>{{'multi_tariff.rates.period_to' | translate}}</th>
							<th>{{'multi_tariff.rates.period_price' | translate}} <span *ngIf="selectedCurrency">({{selectedCurrency}})</span></th>
							<th *ngIf="!readonly"></th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let period of rate.periods; let periodIndex = index">
							<td>
								<input
									type="text"
									class="form-control form-control-sm"
									name="periodName{{rateIndex}}_{{periodIndex}}"
									maxlength="100"
									[disabled]="readonly"
									[ngClass]="{'border border-danger': invalidFields?.rates?.[rateIndex]?.periods?.[periodIndex]?.name}"
									[(ngModel)]="period.name"
									(ngModelChange)="emit()"
								/>
							</td>
							<td>
								<input
									type="time"
									class="form-control form-control-sm"
									name="periodFrom{{rateIndex}}_{{periodIndex}}"
									[disabled]="readonly"
									[ngClass]="{'border border-danger': invalidFields?.rates?.[rateIndex]?.periods?.[periodIndex]?.from}"
									[(ngModel)]="period.from"
									(ngModelChange)="emit()"
								/>
							</td>
							<td>
								<input
									type="time"
									class="form-control form-control-sm"
									name="periodTo{{rateIndex}}_{{periodIndex}}"
									[disabled]="readonly"
									[ngClass]="{'border border-danger': invalidFields?.rates?.[rateIndex]?.periods?.[periodIndex]?.to}"
									[(ngModel)]="period.to"
									(ngModelChange)="emit()"
								/>
							</td>
							<td>
								<input
									type="number"
									class="form-control form-control-sm"
									name="periodPrice{{rateIndex}}_{{periodIndex}}"
									min="0"
									[disabled]="readonly"
									[ngClass]="{'border border-danger': invalidFields?.rates?.[rateIndex]?.periods?.[periodIndex]?.price}"
									[(ngModel)]="period.price"
									(ngModelChange)="emit()"
								/>
							</td>
							<td *ngIf="!readonly">
								<button
									type="button"
									class="btn btn-sm btn-link text-danger"
									(click)="removePeriod(rateIndex, periodIndex)"
								>
									{{'g.delete' | translate}}
								</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<button
				*ngIf="!readonly"
				type="button"
				class="btn btn-sm btn-outline-primary"
				[disabled]="rate.periods.length >= maxPeriods"
				(click)="addPeriod(rateIndex)"
			>
				{{'multi_tariff.rates.add_period' | translate}}
			</button>
		</div>

		<div *ngIf="!rates.length" class="text-muted">{{'g.no_data_available' | translate}}</div>
	</div>
</div>
